import React, { useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Button, Tooltip } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  DriveTour,
  FilterButton,
  Page,
  Permitted,
} from 'components'
import {
  DocumentCreationModeDialog,
  DocumentsFilters,
  DocumentTemplates,
} from './components'

import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePermissions from 'hooks/usePermissions'

import theme from 'theme'
import * as services from 'service'
import constants from 'constants/index'

const DocumentsMain = ({ match }) => {
  const { folderId } = match?.params

  const { DOCUMENT_TEMPLATES_CATEGORY_ID } = constants.documents

  const {
    MAIN_STEPS_OBJECT,
    MAIN_STEP_1,
    MAIN_STEP_2,
    MAIN_STEP_3,
    MAIN_STEP_4,
    MAIN_STEP_6,
  } = constants.tours.documents

  const { PRIVACY_POLICIES, DOCUMENTS_TEMPLATE } = constants.permissions

  const [openTour, setOpenTour] = useState(false)
  const [folderName, setFolderName] = useState('')

  const filter = useFilter()
  const permissions = usePermissions()

  const { response, isLoading } = useFetch(
    services.dponet.documentCategories.get,
    {},
    [],
  )

  const documentCategories = response?.data?.documentCategories

  const docCreatePermission = permissions.permitted(PRIVACY_POLICIES.CREATE)
  const docListPermission = permissions.permitted(PRIVACY_POLICIES.LIST)
  const modelListPermission = permissions.permitted(DOCUMENTS_TEMPLATE.LIST)

  const filteredSteps = MAIN_STEPS_OBJECT.filter((step) => {
    if (!docCreatePermission) return step.element !== '#' + MAIN_STEP_2
    if (!docListPermission) return step.element !== '#' + MAIN_STEP_3
    if (!modelListPermission) return step.element !== '#' + MAIN_STEP_4
    if (!docListPermission) return step.element !== '#' + MAIN_STEP_6

    return true
  })

  const handleOpenTour = () => {
    const where = 'Documentos'
    const params = {
      action: 'tour-listagem-documentos',
    }

    helpers.mixpanel.track(where, 'Tour', params)
    setOpenTour(true)
  }

  return (
    <Page title="Pasta de documentos">
      <Container maxWidth={false}>
        <ContentHeader
          title="Pasta de documentos"
          subTitle={folderName}
          goBack
          gridGap={theme.spacing(2)}
        >
          <Tooltip title="Iniciar o tour guiado">
            <Button
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={handleOpenTour}
              id={MAIN_STEP_1}
              fullWidth
            >
              Tutorial
            </Button>
          </Tooltip>
          <Permitted tag={PRIVACY_POLICIES.CREATE}>
            <DocumentCreationModeDialog id={MAIN_STEP_2} />
          </Permitted>
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <DocumentTemplates
          filter={filter}
          folderId={folderId}
          onFolderLoad={(folder) => setFolderName(folder.name)}
        />
      </Container>
      <DocumentsFilters
        filter={filter}
        currentTab={DOCUMENT_TEMPLATES_CATEGORY_ID}
        categories={documentCategories}
        loadingCategories={isLoading}
      />
      <DriveTour
        stepsMatrix={filteredSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default DocumentsMain
